import { defineStore } from 'pinia'

export default defineStore('layout', {
  state: () => ({
    isLoading: false,
    loadingText: null,
    modalName: null,
    modalCanClose: true,
  }),

  actions: {
    startLoading(loadingText) {
      this.isLoading = true
      this.loadingText = loadingText
    },

    stopLoading() {
      this.isLoading = false
      this.loadingText = null
    },

    showModal(modalName, data) {
      this.modalName = modalName
      this.modalData = data
    },

    closeModal() {
      this.modalName = null
      this.modalCanClose = true
    },
  },
})